import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { NgForm } from "@angular/forms";
import { MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import { throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { EssentialService } from "../../services/essential.service";
import { FormBuilderService } from "../../services/form-builder.service";
export interface IFormModel {
  captcha?: string;
}
@Component({
  selector: "app-form-builder",
  templateUrl: "./form-builder.component.html",
  styleUrls: ["./form-builder.component.css"],
})
export class FormBuilderComponent implements OnInit {
  @Input() public settings: any;
  @Input() public data: any;

  public message: string;
  public fileError = false;
  public filePath: any;
  public error: string;
  public site: any;
  @ViewChild("popupBefor", { read: TemplateRef, static: true })
  public popupBefor: TemplateRef<any>;
  public popupBeforRef: any;
  @ViewChild("popupAfter", { read: TemplateRef, static: true })
  public popupAfter: TemplateRef<any>;
  public popupAfterRef: any;
  public loading = false;
  public formModel: IFormModel = {};
  emailmessage: any;
  emailsubmittermessage: any;
  APIData: any[] = [];
  showEditor = false
  constructor(
    public router: Router,
    private dialog: MatDialog,
    private essentialsService: EssentialService,
    private fbService: FormBuilderService,
    private httpClient: HttpClient
    //private snackBar: MatSnackBar
  ) { }

  public ngOnInit() {
    this.site = this.data.moduleService.site;
    for (const block of this.settings.blocks) {
      if (
        block.element.setting.dataSource === "api" &&
        (block.element.type === "DDL" ||
          block.element.type === "Radio" ||
          block.element.type === "CheckBox")
      ) {
        this.getData(block);
        // } if (block.element.type == 'summernote')
        //   {
        //     setTimeout(() => {
        //               this.showEditor = true

        //     }, 2000);
      }

      this.getName(block);
      this.getDepartment(block);
      this.getDepartmentId(block);
    }

  }
  public getTemplateId() {
    if (this.settings.formReciveMessage) {
       this.httpClient
        .get(
          `/EmailTemplate/GetEmailTemplateById/${this.settings.formReciveMessage}`
        )
        .subscribe((res: any) => {
          this.emailmessage = res.emailBody;
          this.settings.emailMessage = res.emailBody;
 

        });
    }
    if (this.settings.formReciveSubmiterMessage) {
       this.httpClient
        .get(
          `/EmailTemplate/GetEmailTemplateById/${this.settings.formReciveSubmiterMessage}`
        )
        .subscribe((res: any) => {
          this.emailsubmittermessage = res.emailBody;
          this.settings.formSubmitteremailMessage = res.emailBody;
 
        });
    }
  }
  public back() {
    window.history.back();
  }
  public getData(block) {
    if (block.element.setting.dataSource == "api") {
      this.essentialsService
        .getData(block.element.setting.apiName)
        .subscribe((res: any) => {
          block.options = [];
          if (block.element.setting.apiParams) {
            const keys = block.element.setting.apiParams.split("=>");
            let obj = res;
            for (const key of keys) {
              obj = obj[key] ? obj[key] : [];
            }
            block.options = obj ? obj : [];
          } else {
            block.options = res && res.length ? res : [];
          }
        });
    }
  }

  public onSelectFile(event, block) {
    if (event.target.files && event.target.files.length) {
      block.element.value = event.target.files;
    }
  }
  public callFormApiUrl() {
     const values = {};

    for (const block of this.settings.blocks) {
      if (block.element.type === "CheckBox") {
        values[block.element.key] = block.element.setting.options;
      } else {
        values[block.element.key] = block.element.value || null;
      }
    }
    this.fbService
      .invokeApi(this.settings.apiType, this.settings.apiURL, values)
      .subscribe(
        (res: any) => {
          this.dialog.closeAll();
          if (this.settings.showPopupAfter) {
            // this.snackBar.open(this.settings.MessageAfter, "Sucess", {
            //   duration: 2000,
            // });
          }
          if (this.settings.redirectType) this.redirectAction(res);
        },
        (err) => {
          this.loading = false;
          // this.snackBar.open(
          //   err.error ? err.error : "Something went wrong",
          //   "",
          //   {
          //     duration: 2000,
          //   }
          // );
        }
      );
  }
  public saveFormAndSendEmail() {
     this.getTemplateId();
    setTimeout(() => {
      this.saveData();
    }, 1000);
  }
  public saveData() {
    const values = {};
    const formData: FormData = new FormData();

    for (const block of this.settings.blocks) {
      if (block.element.type === "CheckBox") {
        values[block.element.key] = block.element.setting.options;
      } else if (block.element.type === "Upload") {
        if (block.element.value && block.element.value.length) {
          for (const f of block.element.value) {
            formData.append(block.element.key, f);
          }
        }
      } else if (
        block.element.type === "DDL" &&
        block.element.setting.dataSource == "api"
      ) {
        block.options.forEach((element) => {
          if (element[block.element.setting.dataKey] == block.element.value) {
            values[block.element.key] = element[block.element.setting.dataLabel]
          }
        });
      }  
      else {
        values[block.element.key] = block.element.value || null;
      }
    }

    const submitter = [];
    if (
      this.settings.formSubmitter &&
      values[this.settings.formEmailKeys.toString()] &&
      values[this.settings.formEmailKeys.toString()] != null
    ) {
      submitter.push(values[this.settings.formEmailKeys.toString()]);
    }

    const data = {
      SiteId: +this.site.id,
      FormName: this.settings.formName,
      FormData: JSON.stringify(values),
      MailSender: this.settings.emailFrom || "",
      MailReceiver: this.settings.emailsTo || [],
      MailSubject: this.settings.emailSubject || "",
      MailMessage: this.settings.emailMessage || "",
      AttacheFolder: this.settings.formSubmitter || "",
      SubmitterMailReceiver: submitter || [],
      SubmitterMailSubject: (this.settings.sendEmail =
        this.settings.formSubmitterSubject || ""),
      SubmitterMailMessage: (this.settings.sendEmail =
        this.settings.formSubmitteremailMessage || ""),
      SMSSender: "",
      SMSReceiver: "",
      SubmitionDate: new Date(),
    };

    formData.append("data", JSON.stringify(data));
     this.fbService.saveForm(formData)
      // .pipe(
      //   tap((res)=>{
      //     debugger 
      //     console.log(res)
      //   }),
      //   catchError((err: any) => {
      //     debugger 
      //     return throwError(err.message)
      //   })
      // )
      .subscribe(
        (res: any) => {
           this.dialog.closeAll();
          this.loading = false;
          if (this.settings.showPopupAfter) {
            this.popupAfterRef = this.dialog.open(this.popupAfter, {
              width: "600px",
            });
            this.popupAfterRef.afterClosed().subscribe(() => { });
          } else if (this.settings.redirectType) {
            this.redirectAction();
          }
        },
        (err) => {
          this.dialog.closeAll();
          this.loading = false;
          // throw Error('Invalid Email Confingration')
          // this.snackBar.open(err.message, "", {
          //   duration: 2000,
          // });
          // this.openNotify(err.message);
        }
      );
  }
  public openNotify(message: string) {
    // this.snackBar.open(message, '', {
    //   duration: 2000,
    // });
 
  }
  public resetClick(form: NgForm) {
    form.resetForm();
  }
  public cancelClick() {
    // this.location.back();
  }
  public submitClick(form) {
 
    if (form.invalid && this.fileError !== true) {
       Object.keys(form.controls).forEach((feild) => {
        form.controls[feild].markAsTouched(true);
 
      });
      this.error = "The form must be filled out";
      return;
    }
    if (this.settings.showPopupBefore) {
      this.popupBeforRef = this.dialog.open(this.popupBefor, {
        width: "600px",
      });
      this.popupBeforRef.afterClosed().subscribe(() => {
        this.loading = false;
      });
    } else {
      this.okBeforeClick();
    }
  }

  redirectAction(apiResponse?) {
    if (this.settings.redirectType == "2") {
      this.router.navigate([this.settings.redirectTypePage]);
    } else if (this.settings.redirectType == "3") {
      this.router.navigate([this.settings.url]);
    } else if (this.settings.redirectType === 1) {
      this.router.navigate([apiResponse]);
    }
  }

  public closePopup() {
    this.loading = false;
    this.dialog.closeAll();
    this.loading = false;
    if (this.popupAfterRef) this.popupAfterRef.close();
  }

  public okBeforeClick() {
    this.loading = true;
    if (this.settings.actionType === "callApi") {
       this.callFormApiUrl();
    } else {
      this.saveFormAndSendEmail();
    }
  }
  public getName(block?) {
    if (this.settings.isactivedirectory) {
      let x = localStorage.getItem('adFullName');
      if (block.element.key == "Employeename") {
        block.element.value = x
      }
    }
  }
  public getDepartment(block?) {
    if (this.settings.isactivedirectory) {
      let x = localStorage.getItem('adUserGroupName');
      if (block.element.key == "Groupname") {
        block.element.value = x
      }
    }
  }
  public getDepartmentId(block?) {
    if (this.settings.isactivedirectory) {
      let x = localStorage.getItem('adUserGroupId');
      if (block.element.key == "GroupId") {
        block.element.value = x
      }
    }
  }
}
